<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: function (to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss">
@import url("https://cdn.bootcss.com/font-awesome/4.7.0/css/font-awesome.css");

ul,
ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
li {
  list-style: none;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1280px;
  overflow: hidden;
}
body {
  background: #f4f9fa;
}
a,
a:hover {
  color: #fff !important;
}
.wd {
  min-width: 1280px;
  max-width: 1280px;
  // width: 100%;
  margin: 0 auto;
}
.vm {
  vertical-align: middle !important;
}
.carousel {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue